import { authFetch } from "../utils/authFetch"
import { API_BASE_URL } from "../config"

const baseUrl = `${API_BASE_URL}/api/sucursal-fotografias`

/** Lista las fotografías (URLs) de una sucursal. */
export const getFotosBySucursal = async (sucursalId) => {
  const response = await authFetch(`${baseUrl}/sucursal/${sucursalId}`, { method: "GET" })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al consultar las fotos: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}

/** Agrega una foto (URL) a una sucursal. */
export const createFoto = async (idSucursal, fotografia) => {
  const response = await authFetch(baseUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ idSucursal, fotografia }),
  })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al agregar la foto: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}

/** Actualiza la URL de una foto. */
export const updateFoto = async (id, fotografia) => {
  const response = await authFetch(`${baseUrl}/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ fotografia }),
  })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al actualizar la foto: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}

/** Elimina una foto. */
export const deleteFoto = async (id) => {
  const response = await authFetch(`${baseUrl}/${id}`, { method: "DELETE" })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al eliminar la foto: ${errorText || "Sin detalles"}`)
  }
  return { success: true }
}
